import { createEnv } from '@t3-oss/env-core'
import { z } from 'zod/v4'

import { sdkEnv } from '@package/sdk/env'
import { triggerEnv } from '@package/trigger/env'
import { utilsEnv } from '@helper/utils/env'

export function cmsEnv() {
  return createEnv({
    extends: [sdkEnv(), utilsEnv(), triggerEnv()],
    server: {
      PAYLOAD_SECRET: z.string().min(1),
      PAYLOAD_DATABASE_URL: z.string().min(1),
      NODE_ENV: z.enum(['development', 'production']).optional(),
    },
    clientPrefix: 'NEXT_PUBLIC',
    client: {
      NEXT_PUBLIC_PROD_ENV: z.enum(['development', 'production', 'staging']).optional(),
      NEXT_PUBLIC_PAYLOAD_LIVE_PREVIEW_TOKEN: z.string().min(1),
    },
    runtimeEnv: process.env,
    skipValidation:
      !!process.env.CI ||
      process.env.npm_lifecycle_event === 'lint' ||
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      typeof (globalThis as any).window !== 'undefined', // Skip in browser
  })
}
